import { ChainOfResponsibilityHandler } from './chainOfResponsibilityHandler';

export type ChainBuilder<HandleArgs> = {
  addHandler: (h: ChainOfResponsibilityHandler<HandleArgs>) => ChainBuilder<HandleArgs>;
  build: () => (args: HandleArgs) => void | Promise<void>;
};

export const chainBuilder = <HandleArgs>(): ChainBuilder<HandleArgs> => {
  const handlers: ChainOfResponsibilityHandler<HandleArgs>[] = [];

  const addHandler = (h: ChainOfResponsibilityHandler<HandleArgs>) => {
    handlers.push(h);
    return builder;
  };

  const build = () => {
    for (let i = 0; i < handlers.length - 1; i++) {
      handlers[i].setNext(handlers[i + 1]);
    }
    return handlers[0].handle;
  };

  const builder = { addHandler, build };
  return builder;
};
